export interface TransformBoundingBox {
  bottom: number;
  height: number;
  left: number;
  midX: number;
  midY: number;
  right: number;
  top: number;
  width: number;
}

export function getClientRectWithMargin(
  element: HTMLElement,
): TransformBoundingBox {
  const {
    top: innerTop,
    left: innerLeft,
    width: innerWidth,
    height: innerHeight,
  } = element.getBoundingClientRect();
  const { marginLeft, marginRight, marginTop, marginBottom } =
    getComputedStyle(element);
  const parseComputed = (pixelVal: string) =>
    pixelVal
      ? parseFloat(pixelVal.replace("px", "")) *
        (innerWidth / element.offsetWidth)
      : 0;
  const left = innerLeft - parseComputed(marginLeft);
  const right = innerLeft + innerWidth + parseComputed(marginRight);
  const top = innerTop - parseComputed(marginTop);
  const bottom = innerTop + innerHeight + parseComputed(marginRight);
  const midX = (left + right) / 2;
  const midY = (top + bottom) / 2;
  const width =
    innerWidth + parseComputed(marginLeft) + parseComputed(marginRight);
  const height =
    innerHeight + parseComputed(marginBottom) + parseComputed(marginTop);

  return { width, height, top, bottom, left, right, midX, midY };
}

export function reduceTransformBoundingBoxes(
  boxes: Array<TransformBoundingBox>,
) {
  let { top, bottom, left, right } = boxes[0];
  for (const box of boxes) {
    top = Math.min(box.top, top);
    bottom = Math.max(box.bottom, bottom);
    left = Math.min(box.left, left);
    right = Math.max(box.right, right);
  }

  return {
    top,
    bottom,
    midY: (bottom + top) / 2,
    left,
    right,
    midX: (right + left) / 2,
    width: right - left,
    height: bottom - top,
  };
}
